import { Box, Typography, useTheme } from "@mui/material";
import { ShopOrderOperationApi } from "src/api/generated/erp/production/api/shopOrderOperation/shopOrderOperationApi.ts";
import { ShopOrderOperationState } from "src/api/generated/erp/db/types/enums/shopOrderOperationState.ts";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";

export interface ShopOrderStateViewProps {
	shopOrderId: number;
}

export const ShopOrderStateView = ({ shopOrderId }: ShopOrderStateViewProps) => {
	return (
		<AsyncFetchRender
			fetch={() => ShopOrderOperationApi.getShopOrderOperations({ shopOrderId })}
			content={(operations) => (
				<Box
					sx={{
						flex: 1,
						display: "grid",
						gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
						alignItems: "stretch",
						gap: 2,
						padding: 2,
					}}
				>
					{operations.map((operation) => (
						<OperationBox
							key={operation.shopOrderOperationId}
							operationNo={operation.operationNo ?? ""}
							operationDescription={operation.operationDescription ?? ""}
							state={operation.shopOrderOperationState}
						/>
					))}
				</Box>
			)}
		/>
	);
};

interface OperationBoxProps {
	operationNo: string;
	operationDescription: string;
	state: ShopOrderOperationState;
}

const OperationBox = ({ operationNo, operationDescription, state }: OperationBoxProps) => {
	const {palette } = useTheme();
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				borderRadius: 1,
				padding: 2,
				minHeight: 80,
				...getStateStyles(state),
			}}
		>
			<Typography variant="subtitle1" sx={{ fontWeight: "bold", textAlign: "center" }}>
				{operationNo}
			</Typography>
			<Typography variant="body2" sx={{ textAlign: "center" }}>
				{operationDescription}
			</Typography>
		</Box>
	);

	function getStateStyles(state: ShopOrderOperationState) {
		switch (state) {
			case "RELEASED":
				return {
					backgroundColor: palette.state.released,
					color: "#fff",
				};
			case "STARTED":
				return {
					backgroundColor: palette.state.inProgress,
					color: "#000",
				};
			case "READY":
				return {
					backgroundColor: palette.state.completed,
					color: "#fff",
				};
		}
	}
};
